/**
 * LevelIcons — len NOVÉ ikony pre levely + mapovanie level → ikona (1–60) a tier → ikona.
 *
 * Staré ikony sa len referencujú menom (z BuzerIcons, príp. sprout z BadgeIcons).
 * NOVÉ ikony (NEW_LEVEL_ICONS) pridaj do `ICONS` v BuzerIcons.tsx:
 *     import { NEW_LEVEL_ICONS } from "./LevelIcons";
 *     Object.assign(ICONS, NEW_LEVEL_ICONS);
 * Potom funguje <BuzerIcon name="gamepad" /> aj všetky level ikony.
 *
 * Náhrady (emoji bez dobrej line-ikony, nahradené existujúcou — pokojne povedz a dokreslím):
 *   Lv31 🦾 → dumbbell · Lv48 🐉 → flame · Lv60 🦄 → ai · tier "Majster" 🦾 → dumbbell
 *
 * Štýl: 24×24, stroke = currentColor, round cap/join (rovnako ako zvyšok sady).
 */

export const NEW_LEVEL_ICONS: Record<string, { label: string; cat: string; svg: string }> = {
  "gamepad": {
    "label": "Ovládač",
    "cat": "ucenie",
    "svg": "<rect x=\"3\" y=\"8\" width=\"18\" height=\"9\" rx=\"4.5\"/><line x1=\"7\" y1=\"11\" x2=\"7\" y2=\"14\"/><line x1=\"5.5\" y1=\"12.5\" x2=\"8.5\" y2=\"12.5\"/><circle cx=\"15.5\" cy=\"11.5\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"17.5\" cy=\"13.5\" r=\"0.9\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "fuel": {
    "label": "Pumpa",
    "cat": "praca",
    "svg": "<path d=\"M5 20 V6 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 v14\"/><line x1=\"4\" y1=\"20\" x2=\"14\" y2=\"20\"/><rect x=\"7\" y=\"7\" width=\"4\" height=\"3.5\" rx=\"0.5\"/><path d=\"M13 9 h3 a1.5 1.5 0 0 1 1.5 1.5 V15 a1 1 0 0 0 2 0 V9 l-2 -2\"/>"
  },
  "train": {
    "label": "Vlak",
    "cat": "praca",
    "svg": "<rect x=\"4\" y=\"6\" width=\"12\" height=\"9\" rx=\"2\"/><path d=\"M16 9 h2 l2.5 3 v3 H16Z\"/><line x1=\"4\" y1=\"15\" x2=\"20.5\" y2=\"15\"/><circle cx=\"8\" cy=\"18\" r=\"1.5\"/><circle cx=\"16\" cy=\"18\" r=\"1.5\"/><line x1=\"6\" y1=\"9.5\" x2=\"14\" y2=\"9.5\"/>"
  },
  "bull": {
    "label": "Býk",
    "cat": "priroda",
    "svg": "<path d=\"M5.5 6 C8 5.5 8.5 8 8.3 9.3\"/><path d=\"M18.5 6 C16 5.5 15.5 8 15.7 9.3\"/><path d=\"M8 9 a4 4 0 0 0 8 0 v2.5 a4 4 0 0 1 -8 0Z\"/><circle cx=\"10.4\" cy=\"10.5\" r=\"0.6\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"13.6\" cy=\"10.5\" r=\"0.6\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "ban": {
    "label": "Zákaz",
    "cat": "ui",
    "svg": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><line x1=\"6.4\" y1=\"6.4\" x2=\"17.6\" y2=\"17.6\"/>"
  },
  "award": {
    "label": "Vyznamenanie",
    "cat": "socialne",
    "svg": "<path d=\"M8.5 3 H15.5\"/><path d=\"M9 3 L11.4 10\"/><path d=\"M15 3 L12.6 10\"/><circle cx=\"12\" cy=\"15.5\" r=\"5.5\"/><path d=\"M12 12.90 C12 14.84 12.76 15.6 14.70 15.6 C12.76 15.6 12 16.36 12 18.30 C12 16.36 11.24 15.6 9.30 15.6 C11.24 15.6 12 14.84 12 12.90 Z\"/>"
  },
  "ufo": {
    "label": "UFO",
    "cat": "priroda",
    "svg": "<ellipse cx=\"12\" cy=\"13\" rx=\"9\" ry=\"3\"/><path d=\"M7.5 12 a4.5 2.8 0 0 1 9 0\"/><circle cx=\"8\" cy=\"13\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"12\" cy=\"13.6\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"16\" cy=\"13\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><line x1=\"6.5\" y1=\"16\" x2=\"5\" y2=\"19\"/><line x1=\"17.5\" y1=\"16\" x2=\"19\" y2=\"19\"/>"
  },
  "robot": {
    "label": "Robot",
    "cat": "ucenie",
    "svg": "<rect x=\"6\" y=\"7\" width=\"12\" height=\"11\" rx=\"2\"/><line x1=\"12\" y1=\"4\" x2=\"12\" y2=\"7\"/><circle cx=\"12\" cy=\"3.5\" r=\"1\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"9.7\" cy=\"11\" r=\"1.3\"/><circle cx=\"14.3\" cy=\"11\" r=\"1.3\"/><line x1=\"9.7\" y1=\"15\" x2=\"14.3\" y2=\"15\"/>"
  },
  "infinity": {
    "label": "Nekonečno",
    "cat": "ui",
    "svg": "<path d=\"M12 12 C10.5 9.3 6.5 9.3 6.5 12 C6.5 14.7 10.5 14.7 12 12 C13.5 9.3 17.5 9.3 17.5 12 C17.5 14.7 13.5 14.7 12 12Z\"/>"
  },
  "swords": {
    "label": "Meče",
    "cat": "socialne",
    "svg": "<line x1=\"5\" y1=\"19\" x2=\"15.5\" y2=\"8.5\"/><line x1=\"19\" y1=\"19\" x2=\"8.5\" y2=\"8.5\"/><path d=\"M15.5 8.5 L17 5 L13.5 6.5Z\"/><path d=\"M8.5 8.5 L7 5 L10.5 6.5Z\"/><line x1=\"4\" y1=\"17\" x2=\"7\" y2=\"20\"/><line x1=\"20\" y1=\"17\" x2=\"17\" y2=\"20\"/>"
  },
  "rock": {
    "label": "Skala",
    "cat": "priroda",
    "svg": "<path d=\"M4 17 L7 9.5 L13 7.5 L19.5 11 L20 16 L15.5 19 H7Z\"/><path d=\"M7 9.5 L12 13 L19.5 11\"/><path d=\"M12 13 L11 19\"/>"
  },
  "chess": {
    "label": "Šach",
    "cat": "ucenie",
    "svg": "<circle cx=\"12\" cy=\"6\" r=\"2.3\"/><path d=\"M10.2 8 C9 9.5 9.4 11 11 12 L9.7 16 h4.6 L13 12 C14.6 11 15 9.5 13.8 8\"/><path d=\"M8 20 h8 l-1.2 -3.5 H9.2Z\"/>"
  },
  "scroll": {
    "label": "Zvitok",
    "cat": "ucenie",
    "svg": "<path d=\"M8 5 h9 a2 2 0 0 1 0 4 H8\"/><path d=\"M8 5 a2 2 0 0 0 -2 2 v10 a2 2 0 0 0 2 2 h9 a2 2 0 0 0 2 -2 v-2 a2 2 0 0 0 -2 -2\"/><line x1=\"10\" y1=\"12\" x2=\"15\" y2=\"12\"/><line x1=\"10\" y1=\"15\" x2=\"15\" y2=\"15\"/>"
  },
  "temple": {
    "label": "Chrám",
    "cat": "ucenie",
    "svg": "<path d=\"M3.5 9 L12 4 L20.5 9Z\"/><line x1=\"3.5\" y1=\"18.5\" x2=\"20.5\" y2=\"18.5\"/><line x1=\"5\" y1=\"9.5\" x2=\"5\" y2=\"18\"/><line x1=\"9\" y1=\"9.5\" x2=\"9\" y2=\"18\"/><line x1=\"15\" y1=\"9.5\" x2=\"15\" y2=\"18\"/><line x1=\"19\" y1=\"9.5\" x2=\"19\" y2=\"18\"/>"
  },
  "comet": {
    "label": "Kométa",
    "cat": "priroda",
    "svg": "<path d=\"M16.5 4.80 C16.5 6.74 17.26 7.5 19.20 7.5 C17.26 7.5 16.5 8.26 16.5 10.20 C16.5 8.26 15.74 7.5 13.80 7.5 C15.74 7.5 16.5 6.74 16.5 4.80 Z\"/><line x1=\"3\" y1=\"19\" x2=\"10\" y2=\"12\"/><line x1=\"6.5\" y1=\"20\" x2=\"11\" y2=\"15.5\"/><line x1=\"3\" y1=\"15\" x2=\"6.5\" y2=\"11.5\"/>"
  },
  "bolt": {
    "label": "Blesk",
    "cat": "priroda",
    "svg": "<path d=\"M13 3 L6 13 h5 l-2 8 L18 10 h-5Z\"/>"
  },
  "galaxy": {
    "label": "Galaxia",
    "cat": "priroda",
    "svg": "<path d=\"M12 12 C12 9.5 15.5 9.5 16 12.5 C16.6 16.5 10.5 18 7.5 14 C4.3 9.7 10.5 4.5 16 6 C21.5 7.5 21 15.5 16.5 18.5\"/><circle cx=\"12\" cy=\"12\" r=\"0.8\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "blackhole": {
    "label": "Čierna diera",
    "cat": "priroda",
    "svg": "<ellipse cx=\"12\" cy=\"12\" rx=\"9\" ry=\"3.2\" transform=\"rotate(-22 12 12)\"/><circle cx=\"12\" cy=\"12\" r=\"3.2\" fill=\"currentColor\" stroke=\"none\"/>"
  },
  "trident": {
    "label": "Trojzubec",
    "cat": "socialne",
    "svg": "<line x1=\"12\" y1=\"9\" x2=\"12\" y2=\"21\"/><line x1=\"12\" y1=\"3\" x2=\"12\" y2=\"9\"/><path d=\"M7 4 V8 a5 4 0 0 0 10 0 V4\"/><path d=\"M7 4 L5.8 6\"/><path d=\"M17 4 L18.2 6\"/><line x1=\"9.5\" y1=\"14\" x2=\"14.5\" y2=\"14\"/>"
  },
  "ninja": {
    "label": "Ninja",
    "cat": "socialne",
    "svg": "<circle cx=\"12\" cy=\"12\" r=\"8\"/><line x1=\"4.5\" y1=\"10.3\" x2=\"19.5\" y2=\"10.3\"/><line x1=\"5\" y1=\"13.8\" x2=\"19\" y2=\"13.8\"/><line x1=\"7.8\" y1=\"12.1\" x2=\"10.3\" y2=\"12.1\"/><line x1=\"13.7\" y1=\"12.1\" x2=\"16.2\" y2=\"12.1\"/>"
  },
  "lion": {
    "label": "Lev",
    "cat": "priroda",
    "svg": "<circle cx=\"12\" cy=\"12.5\" r=\"4.3\"/><circle cx=\"10.4\" cy=\"12\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><circle cx=\"13.6\" cy=\"12\" r=\"0.55\" fill=\"currentColor\" stroke=\"none\"/><path d=\"M11 14 L12 15 L13 14\"/><line x1=\"16.30\" y1=\"12.50\" x2=\"19.20\" y2=\"12.50\"/><line x1=\"15.48\" y1=\"15.03\" x2=\"17.82\" y2=\"16.73\"/><line x1=\"13.33\" y1=\"16.59\" x2=\"14.22\" y2=\"19.35\"/><line x1=\"10.67\" y1=\"16.59\" x2=\"9.78\" y2=\"19.35\"/><line x1=\"8.52\" y1=\"15.03\" x2=\"6.18\" y2=\"16.73\"/><line x1=\"7.70\" y1=\"12.50\" x2=\"4.80\" y2=\"12.50\"/><line x1=\"8.52\" y1=\"9.97\" x2=\"6.18\" y2=\"8.27\"/><line x1=\"10.67\" y1=\"8.41\" x2=\"9.78\" y2=\"5.65\"/><line x1=\"13.33\" y1=\"8.41\" x2=\"14.22\" y2=\"5.65\"/><line x1=\"15.48\" y1=\"9.97\" x2=\"17.82\" y2=\"8.27\"/>"
  }
};

/** Číslo levelu (1–60) → názov ikony.  E=existujúca · B=badge · N=nová · *=náhrada */
export const LEVEL_ICON: Record<number, string> = {
  0: "egg",           // 🥚 Deň nula (Level 0, pred prvým levelom)  [N]
  1: "egg",           // 🐣 Totálna newbie  [E]
  2: "gamepad",       // 🎮 Mačkáčka tlačidiel  [N]
  3: "book",          // 📗 Tutoriálová úroveň  [E]
  4: "footprints",    // 👶 Ešte sa učí chodiť  [E]
  5: "thumbsup",      // ✊ Prvý boss padol  [E]
  6: "sprout",        // 🌱 Zelenáčka  [B]
  7: "herb",          // 🌿 Húževnatý sadeník  [E]
  8: "fuel",          // ⛽ Naberá grády  [N]
  9: "music",         // 🎵 Chytá rytmus  [E]
  10: "calendar",     // 📅 Pravidelníčka  [E]
  11: "flame",        // 🔥 Zapálená  [E]
  12: "train",        // 🚂 Rozbehnutý vlak  [N]
  13: "run",          // 🏃 Neúnavná  [E]
  14: "wave",         // 🌊 Na vlne  [E]
  15: "sparkles",     // ✨ Horiaca séria  [E]
  16: "dumbbell",     // 💪 Vytrvalkyňa  [E]
  17: "bull",         // 🐂 Tvrdohlavá  [N]
  18: "settings",     // ⚙️ Železná vôľa  [E]
  19: "ban",          // 🚫 Bez výhovoriek  [N]
  20: "award",        // 🏅 Maratónka  [N]
  21: "settings",     // ⚙️ Stroj na návyky  [E]
  22: "ufo",          // 🛸 Autopilot  [N]
  23: "wrench",       // 🔧 Dobre namazaný stroj  [E]
  24: "robot",        // 🤖 Neúprosná  [N]
  25: "infinity",     // ♾️ Perpetuum mobile  [N]
  26: "shield",       // 🛡️ Bojovníčka  [E]
  27: "swords",       // ⚔️ Gladiátorka  [N]
  28: "shirt",        // 🥋 Disciplína v tele  [E]
  29: "rock",         // 🪨 Tvrdé jadro  [N]
  30: "award",        // 🎖️ Veteránka  [N]
  31: "dumbbell",     // 🦾 Majsterka  [*]
  32: "ninja",        // 🥷 Sensei  [N]
  33: "music",        // 🎻 Virtuózka  [E]
  34: "meditation",   // 🧘 Majster sústredenia  [E]
  35: "chess",        // ♟️ Veľmajsterka  [N]
  36: "brain",        // 🧠 Guru  [E]
  37: "scroll",       // 📜 Mudrc  [N]
  38: "candle",       // 🕯️ Osvietená  [E]
  39: "compass",      // 🧭 Mentorka  [E]
  40: "megaphone",    // 📣 Životná koučka  [E]
  41: "trophy",       // 🏆 Šampiónka  [E]
  42: "chart",        // 📈 Rekordérka  [E]
  43: "shield",       // 🛡️ Neporaziteľná  [E]
  44: "temple",       // 🏛️ Sieň slávy  [N]
  45: "star2",        // 🌟 Ikona  [E]
  46: "crown",        // 👑 Legenda  [E]
  47: "lion",         // 🦁 Živá legenda  [N]
  48: "flame",        // 🐉 Mýtus  [*]
  49: "rock",         // 🗿 Titanka  [N]
  50: "moon",         // 🌓 Polobožstvo  [E]
  51: "star2",        // 🌟 Mýtická  [E]
  52: "sparkles",     // 💫 Hviezdna  [E]
  53: "comet",        // ☄️ Kozmická  [N]
  54: "ufo",          // 🛸 Nadpozemská  [N]
  55: "hourglass",    // ⏳ Nesmrteľná  [E]
  56: "bolt",         // ⚡ Godlike  [N]
  57: "galaxy",       // 🌌 Vládkyňa vesmíru  [N]
  58: "blackhole",    // 🕳️ Pani času a priestoru  [N]
  59: "trident",      // 🔱 Absolútna sila  [N]
  60: "ai",           // 🦄 Super Godlike  [*]
};

/** Názov tieru → názov ikony */
export const TIER_ICON: Record<string, string> = {
  "Nováčik": "egg",               // 🐣  [E]
  "Zelenáč": "sprout",            // 🌱  [B]
  "Zapálenec": "flame",           // 🔥  [E]
  "Vytrvalec": "dumbbell",        // 💪  [E]
  "Stroj": "settings",            // ⚙️  [E]
  "Bojovník": "shield",           // 🛡️  [E]
  "Majster": "dumbbell",          // 🦾  [*]
  "Guru": "brain",                // 🧠  [E]
  "Šampión": "trophy",            // 🏆  [E]
  "Legenda": "crown",             // 👑  [E]
  "Mýtický": "star2",             // 🌟  [E]
  "Super Godlike": "bolt",        // ⚡  [N]
};

/**
 * Render:
 *   import { BuzerIcon } from "./BuzerIcons";
 *   import { LEVEL_ICON } from "./LevelIcons";
 *   <BuzerIcon name={LEVEL_ICON[user.level]} size={24} />
 *
 * --- Backend (Python), ak chceš nahradiť emoji za názvy ikon ---
 * LEVEL_ICON_PY = {
 *   1:"egg", 2:"gamepad", 3:"book", 4:"footprints", 5:"thumbsup",
 *   6:"sprout", 7:"herb", 8:"fuel", 9:"music", 10:"calendar",
 *   11:"flame", 12:"train", 13:"run", 14:"wave", 15:"sparkles",
 *   16:"dumbbell", 17:"bull", 18:"settings", 19:"ban", 20:"award",
 *   21:"settings", 22:"ufo", 23:"wrench", 24:"robot", 25:"infinity",
 *   26:"shield", 27:"swords", 28:"shirt", 29:"rock", 30:"award",
 *   31:"dumbbell", 32:"ninja", 33:"music", 34:"meditation", 35:"chess",
 *   36:"brain", 37:"scroll", 38:"candle", 39:"compass", 40:"megaphone",
 *   41:"trophy", 42:"chart", 43:"shield", 44:"temple", 45:"star2",
 *   46:"crown", 47:"lion", 48:"flame", 49:"rock", 50:"moon",
 *   51:"star2", 52:"sparkles", 53:"comet", 54:"ufo", 55:"hourglass",
 *   56:"bolt", 57:"galaxy", 58:"blackhole", 59:"trident", 60:"ai",
 * }
 */
